import './animated-ellipsis.css'

/**
 * Three fading dots for in-progress copy (e.g. "Applying headers & footers...").
 * Place immediately after the message text inside the same block element.
 */
export function AnimatedEllipsis() {
  return (
    <>
      <span className="ellipsis-dot" aria-hidden>
        .
      </span>
      <span className="ellipsis-dot" aria-hidden>
        .
      </span>
      <span className="ellipsis-dot" aria-hidden>
        .
      </span>
    </>
  )
}
